import axios from 'axios'
import { config, url } from '../../index'

const state = () => ({
  // состояния полей создаваемого отдела
  newDepartment: {
    name: '',
    head: { id: null, name: 'Не назначен' },
    ckp: '',
    duties: '',
    instructions: '',
    folder: '',
    staff: [],
    parent: { id: null, name: 'Не указан', type: null },
    type: { id: null, name: '' }
  },
  // состояния модальных окон
  modals_active: {
    success: false,
    error: false
  },
  validation: {
    name: {},
    head: {},
    parent: {}
  }
})

const getters = {
  newDepartment: state => state.newDepartment,
  departmentCreatePageModals: state => state.modals_active,
  departmentCreateValidation: state => state.validation
}

const mutations = {
  SET_NEW_DEPARTMENT_NAME: (state, name) => {
    state.newDepartment.name = name
  },
  SET_NEW_DEPARTMENT_HEAD: (state, head) => {
    state.newDepartment.head = head
  },
  SET_NEW_DEPARTMENT_PARENT: (state, parent) => {
    state.newDepartment.parent = parent
  },
  SET_NEW_DEPARTMENT_CKP: (state, ckp) => {
    state.newDepartment.ckp = ckp
  },
  SET_NEW_DEPARTMENT_DUTIES: (state, duties) => {
    state.newDepartment.duties = duties
  },
  SET_NEW_DEPARTMENT_INSTRUCTIONS: (state, instructions) => {
    state.newDepartment.instructions = instructions
  },
  SET_NEW_DEPARTMENT_FOLDER: (state, folder) => {
    state.newDepartment.folder = folder
  },
  ADD_NEW_DEPARTMENT_STAFF_USER: (state, staffUser) => {
    state.newDepartment.staff.push(staffUser)
  },
  REMOVE_NEW_DEPARTMENT_STAFF_USER: (state, staffUser) => {
    state.newDepartment.staff = state.newDepartment.staff.filter(user => {
      return user.id !== staffUser.id
    })
  },
  SET_NEW_DEPARTMENT_TYPE: (state, type) => {
    state.newDepartment.type = type
  },
  DEPARTMENT_CREATE_CLEAR_FIELDS: (state) => {
    state.newDepartment.name = ''
    state.newDepartment.type = { id: null, name: '' }
    state.newDepartment.head = { id: null, name: 'Не назначен' }
    state.newDepartment.parent = { id: null, name: 'Не указан' }
    state.newDepartment.ckp = ''
    state.newDepartment.duties = ''
    state.newDepartment.instructions = ''
    state.newDepartment.folder = ''
    state.newDepartment.staff = []
  },
  DEPARTMENT_CREATE_MODAL_SUCCESS_SHOW: (state) => {
    state.modals_active.success = true
  },
  DEPARTMENT_CREATE_MODAL_ERROR_SHOW: (state) => {
    state.modals_active.error = true
  },
  DEPARTMENT_CREATE_MODALS_CLOSE: (state) => {
    state.modals_active = {
      success: false,
      error: false
    }
  },
  DEPARTMENT_CREATE_SET_VALIDATION: (state, errors) => {
    if (errors.name) {
      state.validation.name = { type: 'error', message: errors.name[0] }
    }
  },
  DEPARTMENT_CREATE_VALIDATION_CLEAR: (state, input) => {
    if (input === 'name') {
      state.validation.name = {}
    } else if (input === 'head') {
      state.validation.head = {}
    } else if (input === 'parent') {
      state.validation.parent = {}
    }
  }
}

const actions = {
  // СОЗДАТЬ ОТДЕЛ
  setNewDepartmentName ({ commit }, name) {
    commit('SET_NEW_DEPARTMENT_NAME', name)
  },
  setNewDepartmentHead ({ commit }, head) {
    commit('SET_NEW_DEPARTMENT_HEAD', head)
  },
  setNewDepartmentCkp ({ commit }, ckp) {
    commit('SET_NEW_DEPARTMENT_CKP', ckp)
  },
  setNewDepartmentDuties ({ commit }, duties) {
    commit('SET_NEW_DEPARTMENT_DUTIES', duties)
  },
  setNewDepartmentInstructions ({ commit }, instructions) {
    commit('SET_NEW_DEPARTMENT_INSTRUCTIONS', instructions)
  },
  setNewDepartmentFolder ({ commit }, folder) {
    commit('SET_NEW_DEPARTMENT_FOLDER', folder)
  },
  addNewDepartmentStaffUser ({ commit }, user) {
    commit('ADD_NEW_DEPARTMENT_STAFF_USER', user)
  },
  removeNewDepartmentStaffUser ({ commit }, user) {
    commit('REMOVE_NEW_DEPARTMENT_STAFF_USER', user)
  },
  setNewDepartmentParent ({ commit }, parent) {
    commit('SET_NEW_DEPARTMENT_PARENT', parent)
  },
  setNewDepartmentType ({ commit }, type) {
    commit('SET_NEW_DEPARTMENT_TYPE', type)
  },
  createDepartment ({ state, commit }) {
    const staffIds = state.newDepartment.staff.map(user => {
      return user.id
    })
    const departmentData = {
      name: state.newDepartment.name,
      head_id: state.newDepartment.head.id,
      parent_id: state.newDepartment.parent.id,
      ckp: state.newDepartment.ckp,
      duties: state.newDepartment.duties,
      instruction: state.newDepartment.instructions,
      folder: state.newDepartment.folder,
      type: state.newDepartment.type.id,
      user_ids: staffIds
    }

    axios.post(`${url}/departments`, departmentData, config).then(() => {
      console.log('отдел успешно создан')
      commit('DEPARTMENT_CREATE_MODAL_SUCCESS_SHOW')
      commit('DEPARTMENT_CREATE_CLEAR_FIELDS')
      this.dispatch('getDepartments')
    }).catch(error => {
      console.log(error.response)
      if (error.response.status === 422) {
        commit('DEPARTMENT_CREATE_SET_VALIDATION', error.response.data.validation)
      } else {
        // если ошибка не связанная с валидацией показываем общую модалку ошибки
        commit('DEPARTMENT_CREATE_MODAL_ERROR_SHOW')
        console.log('ошибка создания отдела', error.response)
      }
    })
  },
  closeDepartmentCreateModals ({ commit }) {
    commit('DEPARTMENT_CREATE_MODALS_CLOSE')
  },
  departmentCreateClearFields ({ commit }) {
    commit('DEPARTMENT_CREATE_CLEAR_FIELDS')
  },
  departmentCreateClearValidation ({ commit }, input) {
    commit('DEPARTMENT_CREATE_VALIDATION_CLEAR', input)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
